module.exports = __webpack_public_path__ + "img/cat.65e0297f.jpg";